module.exports = __webpack_public_path__ + "video/800_PAB_2021_WhenToUsePAB.e28daeee.vtt";